import { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { StorageService } from '@/lib/StorageService';

const storageService = new StorageService();

export function AuthenticatedShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(() =>
    storageService.getSidebarCollapsed()
  );

  const handleMenuToggle = useCallback(() => {
    if (window.innerWidth >= 1024) {
      setSidebarCollapsed((prev) => {
        const next = !prev;
        storageService.setSidebarCollapsed(next);
        return next;
      });
    } else {
      setSidebarOpen((prev) => !prev);
    }
  }, []);

  return (
    <div className="flex h-screen flex-col">
      <Header onMenuToggle={handleMenuToggle} />
      <div className="flex flex-1 min-h-0">
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          collapsed={sidebarCollapsed}
          onCollapsedChange={(next) => {
            setSidebarCollapsed(next);
            storageService.setSidebarCollapsed(next);
          }}
        />
        {/* The footer lives inside the scrolling <main>: it sits at the end of the page
            (reached by scrolling) instead of being pinned on screen. On short pages its
            own `mt-auto` pushes it to the bottom of the viewport; the content wrapper is a
            definite-height flex item so full-height pages (`h-full`, e.g. labeling) still
            fill the area above it. */}
        <main className="flex flex-1 flex-col overflow-auto">
          <div className="flex flex-1 flex-col">
            <Outlet />
          </div>
          <Footer />
        </main>
      </div>
    </div>
  );
}
